module.exports = __webpack_public_path__ + "static/media/goat-in-leather-jacket.7741f8b2.png";